import { useSuspenseQuery } from '@tanstack/react-query';
import { paths } from '@/generated/supplier-experience-api';
import apiClient from '@/lib/apiClient';

type Response = paths['/buyers/expansion']['get']['responses']['200']['content']['application/json'];
type ResponseData = Response['data'];

export type BuyerExpansionRequestStatus = ResponseData[0]['status'];

const fetchData = async () => {
  const response = await apiClient.get(`api/supplier-experience/buyers/expansion`).json<Response>();

  return response.data;
};

const useBuyersExpansion = <TData = ResponseData>(select?: (data: ResponseData) => TData) => {
  return useSuspenseQuery({
    queryKey: ['buyers-expansion'],
    queryFn: () => fetchData(),
    select,
  });
};

export default useBuyersExpansion;
